module.exports = __webpack_public_path__ + "static/media/skirting.d64321ad.svg";